import { render, staticRenderFns } from "./StringItem.vue?vue&type=template&id=5288c19c&scoped=true"
import script from "./StringItem.vue?vue&type=script&lang=js"
export * from "./StringItem.vue?vue&type=script&lang=js"
import style0 from "./StringItem.vue?vue&type=style&index=0&id=5288c19c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5288c19c",
  null
  
)

export default component.exports